


























































































































































































import PopupSortPlan from '@/components/common/PopupSortPlan.vue';
import PageLoader from '@components/common/PageLoader.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import ApiHelper from 'api-helper';

@Component({
  components: {
    PageLoader,
    PopupSortPlan,
  },
})
export default class PopupConfirmMenu extends Vue {
  @Prop({
    default() {
      return [];
    },
  })
  public selectedMenus!: any[];

  @Prop({ required: true }) public clinicId!: any;

  public menuSearchString: string = '';
  public tempSelectedMenus: any[] = [];
  public isLoading: boolean = false;
  public allMenus: any[] = [];
  public currentPage: number = 1;
  public lastPage: number = 1;
  public isFetchingMore: boolean = false;
  private observer: IntersectionObserver | null = null;

  public beforeDestroy() {
    this.stopObserving();
  }

  get activeMenuList() {
    return this.allMenus;
  }

  get tempSelectedMenuIds() {
    return this.tempSelectedMenus.map((menu) => menu.id);
  }

  async beforeOpen({ params }) {
    this.menuSearchString = '';
    this.tempSelectedMenus = [...this.selectedMenus];
    await this.fetchMenus(true);
    this.$nextTick(() => this.startObserving());
  }

  async searchByName() {
    await this.fetchMenus(true);
    this.$nextTick(() => this.startObserving());
  }

  async fetchMenus(reset: boolean = false) {
    if (reset) {
      this.isLoading = true;
      this.currentPage = 1;
      this.allMenus = [];
    } else {
      this.isFetchingMore = true;
    }
    try {
      const params: any = {
        clinic_ids: [this.clinicId],
        with: 'plans',
        menu_status: 1,
        per_page: 20,
        page: this.currentPage,
      };
      if (this.menuSearchString) {
        params.name = this.menuSearchString;
      }
      const response = await ApiHelper.getApi('MedicalMenuV2Api').getList(params);
      this.allMenus = [...this.allMenus, ...response.data];
      this.lastPage = response.last_page;
    } catch (e) {
      // silent
    } finally {
      this.isLoading = false;
      this.isFetchingMore = false;
    }
  }

  onScroll(event: Event) {
    const el = event.target as HTMLElement;
    if (
      el.scrollTop + el.clientHeight >= el.scrollHeight - 80
      && !this.isFetchingMore
      && this.currentPage < this.lastPage
    ) {
      this.currentPage++;
      this.fetchMenus();
    }
  }

  startObserving() {
    this.stopObserving();
    const container = this.$refs.scrollContainer as HTMLElement;
    if (!container) {
      return;
    }
    this.observer = new IntersectionObserver(
      (entries) => {
        if (
          entries[0].isIntersecting
          && !this.isFetchingMore
          && this.currentPage < this.lastPage
        ) {
          this.currentPage++;
          this.fetchMenus();
        }
      },
      { root: container, threshold: 0.1 },
    );
    const sentinel = container.querySelector('.scroll-sentinel');
    if (sentinel) {
      this.observer.observe(sentinel);
    }
  }

  stopObserving() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  handleClickMenuCheckbox(event, menu) {
    if (event.target.checked) {
      const menuDto = {
        id: menu.id,
        order: this.tempSelectedMenus.length + 1,
        display: true,
        name: menu.name,
        plans: menu.plans.map((plan, index) => ({
          id: plan.id,
          order: index + 1,
          display: true,
          name: plan.name,
        })),
      };
      this.tempSelectedMenus.push(menuDto);
    } else {
      this.tempSelectedMenus = this.tempSelectedMenus.filter(
        (i) => i.id !== menu.id,
      );

      this.tempSelectedMenus = this.tempSelectedMenus.map((menu, index) => ({
        ...menu,
        order: index + 1,
      }));
    }
  }

  handleChangeMenuOrder(oldIndex, newIndex) {
    if (oldIndex === newIndex - 1) {
      return;
    }

    const movedMenu = this.tempSelectedMenus.splice(oldIndex, 1)[0];

    this.tempSelectedMenus.splice(newIndex - 1, 0, movedMenu);

    this.tempSelectedMenus = this.tempSelectedMenus.map((menu, index) => ({
      ...menu,
      order: index + 1,
    }));
  }

  setPlansForMenu({ menuId, plans }) {
    const updatedMenu = this.tempSelectedMenus.find(
      (menu) => menu.id == menuId,
    );
    updatedMenu.plans = plans.map((plan, index) => ({
      ...plan,
      order: index + 1,
    }));
  }

  get allSelected(): boolean {
    return this.activeMenuList.every((menu) =>
      this.tempSelectedMenuIds.includes(menu.id),
    );
  }

  handleToggleActiveAllMenu() {
    if (this.allSelected) {
      const activeIds = this.activeMenuList.map((menu) => menu.id);
      this.tempSelectedMenus = this.tempSelectedMenus.filter(
        (menu) => !activeIds.includes(menu.id),
      );
    } else {
      const existingIds = this.tempSelectedMenuIds;
      const newMenus = this.activeMenuList
        .filter((menu) => !existingIds.includes(menu.id))
        .map((menu) => ({
          id: menu.id,
          order: this.tempSelectedMenus.length + 1,
          display: true,
          name: menu.name,
          plans: menu.plans.map((plan, index) => ({
            id: plan.id,
            order: index + 1,
            display: true,
            name: plan.name,
          })),
        }));

      this.tempSelectedMenus.push(...newMenus);
    }

    this.tempSelectedMenus = this.tempSelectedMenus.map((menu, index) => ({
      ...menu,
      order: index + 1,
    }));
  }

  submit() {
    this.$emit('submit', this.tempSelectedMenus);
    this.$modal.hide('popup-confirm-menu');
  }

  cancel() {
    this.$modal.hide('popup-confirm-menu');
  }
}
